import { Stack } from '@mui/material';
import { type FlowHumanTaskFieldOption, FlowHumanTaskFieldOptionsVariant } from 'flow-schema';
import * as uuid from 'uuid';

import { Text } from 'common';

import { HumanTaskBlockOption } from './OptionRow';
import { BlockValueTemplateField } from '../../../../../ConfigFields/CodeMirror/FlowTemplate';
import { BlockSelectField } from '../../../../../ConfigFields/SelectField';
import { useSelectedNodeField } from '../../../../../ConfigFields/useSelectedNodeField';
import { type HumanTaskBlockFormFieldsProps } from '../types';

export function HumanTaskBlockFormFieldOptions(props: HumanTaskBlockFormFieldsProps) {
  const { fieldNamePrefix } = props;
  const optionsFieldNamePrefix = `${fieldNamePrefix}.options`;
  const { value: options = [], setValue } =
    useSelectedNodeField<FlowHumanTaskFieldOption[]>(optionsFieldNamePrefix);
  const { value: optionsVariant = FlowHumanTaskFieldOptionsVariant.Static } =
    useSelectedNodeField<FlowHumanTaskFieldOptionsVariant>(`${fieldNamePrefix}.optionsVariant`);

  return (
    <Stack gap={1}>
      <BlockSelectField
        label="Options type"
        fieldName={`${fieldNamePrefix}.optionsVariant`}
        options={[
          {
            label: 'Static',
            value: FlowHumanTaskFieldOptionsVariant.Static,
          },
          {
            label: 'Dynamic',
            value: FlowHumanTaskFieldOptionsVariant.Dynamic,
          },
        ]}
        defaultValue={FlowHumanTaskFieldOptionsVariant.Static}
      />
      {optionsVariant === FlowHumanTaskFieldOptionsVariant.Static && (
        <>
          <Text variant="heading6">Field options</Text>
          <Stack gap={1}>
            {options.map((option, index) => {
              return (
                <HumanTaskBlockOption
                  key={option.id}
                  fieldNamePrefix={`${optionsFieldNamePrefix}.${index}`}
                  label={`Option ${index + 1}`}
                  onAdd={() => {
                    const newValues = [...options];
                    newValues.splice(index + 1, 0, {
                      id: uuid.v4(),
                      label: '',
                    });
                    setValue(newValues);
                  }}
                  onDelete={
                    options.length > 1
                      ? () => {
                          setValue(options.filter((value) => value.id !== option.id));
                        }
                      : undefined
                  }
                />
              );
            })}
          </Stack>
        </>
      )}
      {optionsVariant === FlowHumanTaskFieldOptionsVariant.Dynamic && (
        <BlockValueTemplateField
          label="Options array value"
          fieldName={`${fieldNamePrefix}.dynamicOptions`}
          helperText="An array of strings from a block value template e.g. {{blockName.data}}"
        />
      )}
    </Stack>
  );
}
